import { Button } from "alm-react-components";
import { useEffect, useLayoutEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ApiErrorCode, APPROUTES, ErrorType, FUNDAMENTAL_PROGRAM } from "../../../assets/constants/constants";
import { CourseDetailParmsType } from "../../../interface";
import { apis } from "../../../services/alm";
import PageLoader from "../../common/loader/PageLoader";
import accordionArrowImg from "../../../assets/images/svgicons/accordion-arrow.svg";
import withAlmToken from "../../common/withAlmToken";
import { CourseDetailContainer } from "./course-detail-container/CourseDetailContainer";
import RelatedContent from "./RelatedContent";
import useAlmCorporateStatus from "../../../hooks/useAlmCorporateStatus";

const CourseDetail = () => {
  const { mainLearningProgramId,learningProgramId, courseId } =
    useParams() as CourseDetailParmsType;
  const [programData, setProgramData] = useState<any>(null);
  const [courseResponse, setCourseResponse] = useState<any>(null);
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true);

  const [fundamentalProgram, setFundamentalProgram] = useState(true);
  useAlmCorporateStatus();

  const fetchData = async () => {
    setLoading(true);
    const response :any= await apis.getCourseDetail(mainLearningProgramId);
    //If program is not found in the included courses of the program, redirect to error page.
    if(response?.code === ApiErrorCode.objectDoesntExist){
      navigate(`${APPROUTES.error}/${ErrorType.enrollment}`);
      return
    }
    const isFundamental=response?.data.attributes?.tags.includes(FUNDAMENTAL_PROGRAM); 
    setFundamentalProgram(isFundamental);
    setProgramData(response);
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [courseId]);

  useEffect(() => {
    if (programData && courseId) {
      const newCourseResponse = programData?.included?.find(
        (ele: any) => ele?.id === courseId
      );
      // If course is not found in the included courses of the program, redirect to error page.
      if(newCourseResponse === undefined) {
        navigate(`${APPROUTES.error}/${ErrorType.courseNotFound}`);
        return
      }else {
        setCourseResponse(newCourseResponse);
      }
    }
  }, [programData]);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    if (history.scrollRestoration) {
      history.scrollRestoration = "manual";
    }
  }, []);
  return (
    <div className="flex-grow">
      {loading && <PageLoader />}
      <div className="px-6 pt-6 lg:px-8 xl:pr-32 xl:pl-32 md:pt-14 w-[100%] md:px-8">
        <div className="flex justify-between items-center relative">
            <Button
                onClick={() =>{
                if(fundamentalProgram) navigate(`/program/learningProgram?activeWeek=${learningProgramId}`)
                else navigate(`/program/${mainLearningProgramId}?activeWeek=${learningProgramId}`)
                }}
                variant="default"
                className="dark:bg-fillMidGrayCard w-6 h-6 pl-0 top-0"
            >
              <img src={accordionArrowImg} alt={" "} className="logo cursor-pointer h-[14px] ml-4 rotate-180" />
            </Button>
        </div>
      </div>
      {programData && courseResponse && (
        <CourseDetailContainer
          courseResponse={courseResponse}
          programData={programData}
        />
      )}
      <RelatedContent courseId={courseId} />
    </div>
  );
};

export default withAlmToken(CourseDetail);
